import { useEffect, useRef, useState } from "react"
import { Box, Button, CircularProgress, Stack } from "@mui/material"
import AddCardIcon from '@mui/icons-material/AddCard';

import { useEID } from "../hooks/useEID"
import IDCardIllus from "../../../assets/id_card_illus.png";
import ShareEIDDialogComponent from "../dialogs/shareEID-dialog.component";
import EIDDetailsComponent from "../components/eID-details.component";


const EIDDetailsPage = ({profile_id}) => {

    const [openShareIDDialog, setOpenShareIDDialog] = useState(false)
    const [eIDDetails, setEIDDetails] = useState(null)
    const [eIDQRCode, setEIDQRCode] = useState(null)

    const {
        isLoadingViewEID, 
        eid, 
        errorViewEID, 
        viewEID,

        isLoadingGetEIDInfoQRCode,
        eidInfQRCode,
        errorGetEIDInfoQRCode,
        getEIDInfoQRCode,
    
        isLoadingGenerateEID,
        generatedEID,
        errorGenerateEID,
        generateEID
    } = useEID()

    useEffect(() => {
        if (profile_id) {
            viewEID(profile_id)
            getEIDInfoQRCode()
        }
    }, [profile_id])

    useEffect(() => {
        if (eid) {
            setEIDDetails(eid)
        }
    }, [JSON.stringify(eid)])

    useEffect(() => {
        if (eidInfQRCode) {
            setEIDQRCode(eidInfQRCode.baseURL)
        }
    }, [JSON.stringify(eidInfQRCode)])

    const handleGenerateEID = () => {
        generateEID(profile_id)
    }

    const handleOpenShareEIDDialog = () => {
        setOpenShareIDDialog(true)
    }

    const handleCloseShareEIDDialog = () => {
        setOpenShareIDDialog(false)
    }

    return(
        <>
            {
                isLoadingViewEID ? null :
                eIDDetails && eIDQRCode ?
                <EIDDetailsComponent details={eIDDetails} eIDQRCode={eIDQRCode} />
                :
                <Stack
                    direction="column"
                    flex={1}
                    sx={{
                        justifyContent: "center",
                        alignItems: "center",
                    }}
                    >
                    <Box
                    component="img"
                    src={IDCardIllus}
                    sx={{
                        width: '100%',
                        height: 'auto',
                        maxWidth: '250px',
                        display: 'block',
                        mx: 'auto'
                    }}
                    />
                    <Button 
                        variant="outlined" 
                        startIcon={isLoadingGenerateEID ? <CircularProgress size={20} /> : <AddCardIcon />}
                        sx={{textTransform: 'capitalize'}}
                        onClick={handleGenerateEID}
                    >
                        Generate eID
                    </Button>
                </Stack>
            }

            {openShareIDDialog && 
                <ShareEIDDialogComponent 
                    open={openShareIDDialog} 
                    handleClose={handleCloseShareEIDDialog} 
                />
            }
        </>
    )
}

export default EIDDetailsPage